import { APIConfiguration } from '@savgroup-front-common/configuration';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  SearchOrderDetailsDto,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.owner}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/businessReturns/start`;

interface StartOrContinueBusinessReturnCommandPayload {
  ownerId: string;
  orderReference?: string;
  issueId?: string;
  reasonId?: string;
  sellerId: string;
}

export interface EligibilityItem {
  orderLineReference: string;
  message: string;
}

export interface ReturnEligibility {
  success: boolean;
  errors: EligibilityItem[];
}

export interface BusinessReturnEligibilityResultDto {
  order: SearchOrderDetailsDto;
  eligibility: ReturnEligibility;
}

export const startOrContinueBusinessReturnCommand = async (
  payload: StartOrContinueBusinessReturnCommandPayload,
): Promise<
  BackResponse<BusinessReturnEligibilityResultDto> | BackResponseFailure
> => {
  try {
    return await apiCall<BackResponse<BusinessReturnEligibilityResultDto>>(
      ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, payload.sellerId),
      {
        method: SUPPORTED_METHODS.PUT,
        json: payload,
      },
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
